import React, { useCallback, useEffect, useLayoutEffect, useRef, useState } from 'react'

import t from '../../helpers/i18n'

const MultiSelect = ({ name, label, required, ref, children }) => {
  const [errorMessage, setErrorMessage] = useState()
  const select = useRef()
  const data = useRef(ref || {})

  const fireDataEvent = useCallback(
    (value) => {
      if (name) {
        const event = new CustomEvent('FormDataEvent', {
          bubbles: true,
          cancelable: true,
          detail: {
            name,
            value
          }
        })
        select.current.dispatchEvent(event)
      }
    },
    [name, select]
  )

  const handleChange = useCallback(
    (value, checked) => {
      if (checked) {
        data.current[value] = true
      } else {
        delete data.current[value]
      }
      if (required && Object.keys(data.current).length === 0) {
        fireDataEvent(null)
        setErrorMessage(t('* Requerido'))
      } else {
        fireDataEvent(Object.keys(data.current))
        setErrorMessage(false)
      }
    },
    [data, fireDataEvent, required]
  )

  useLayoutEffect(() => {
    const eventListener = (event) => {
      handleChange(event.detail.value, event.detail.checked)
    }
    const element = select.current
    element.addEventListener('MultiSelectEvent', eventListener, false)
    return () => {
      element.removeEventListener('MultiSelectEvent', eventListener, false)
    }
  }, [select, handleChange])

  useEffect(() => {
    handleChange()
  }, [handleChange])

  return (
    <div ref={select} className='multi-select'>
      <label>{label}</label>
      <div>{children}</div>
      {errorMessage && <span className='-error'>{errorMessage}</span>}
    </div>
  )
}

export default MultiSelect
